import { notEmpty, type Optional } from '@festina-life/core'
import type { MutableRefObject, Ref } from 'react'

/** Merges an array of refs into a single ref so that multiple refs can be given to a single DOM element. */
export const mergeRefs =
  <T>(...refs: Optional<Ref<T>>[]) =>
  (node: T | null) => {
    for (const ref of refs) {
      if (typeof ref === 'function') {
        ref(node)
      } else if (notEmpty(ref)) {
        // Ref is actually a non mutable ref but hasn't been assigned a value yet but we use the callback to initialize it.
        const mutableRef = ref as MutableRefObject<T | null>
        mutableRef.current = node
      }
    }
  }
